const baseUrl = '/corrections';
export const correctionsRoutes = {
  getCorrectionsDetails: "".concat(baseUrl, "/details")
};